module.exports = __webpack_public_path__ + "static/media/apple-watch.5aa35e50.png";